import { Tag } from "~/common/components";
import {
  zoomTranscriptStatusColors,
  zoomTranscriptStatusLabels,
} from "~/providers/constants/zoomTranscriptStatus";
import { ZoomTranscriptStatus } from "~/providers/utils/types/consultation";

interface ZoomTranscriptStatusTagProps {
  status: ZoomTranscriptStatus;
}

export const ZoomTranscriptStatusTag = ({
  status,
}: ZoomTranscriptStatusTagProps) => (
  <Tag className={zoomTranscriptStatusColors[status]}>
    {zoomTranscriptStatusLabels[status]}
  </Tag>
);
